import { CRM_DARK_TINT_01, CRM_LIGHTER_TINT_01, DARK_DEV_GREEN_COLOR_NAME, BACKGROUND_GRAY_COLOR_NAME, WORKFORMS_RED_COLOR_NAME, DARK_WORK_OS_IRIS_COLOR_NAME, BRAND_PRIMARY_GREEN, BRAND_PRIMARY_RED, CRM_DARKER_TINT_02, GAINSBORO_COLOR_NAME, BRAND_BLACK_TEXT_COLOR } from "styles/color-consts";
import colors from "styles/colors";
import { CRM_PRODUCT_ID, DEV_PRODUCT_ID, SERVICE_PRODUCT_ID, WORK_MANAGEMENT_PRODUCT_ID, WORKOS_PLATFORM_PRODUCT_ID } from "constants/products";
export const APPS_NEW = "Apps_new";
export const APPS_RECOMMENDED = "Apps_recommended";
export const APPS_TRENDING = "Apps_trending";
export const INT_TO_ID_MAP = {
    product: {
        1: CRM_PRODUCT_ID,
        2: DEV_PRODUCT_ID,
        5: "workCanvas",
        6: "Work_Forms",
        7: WORK_MANAGEMENT_PRODUCT_ID,
        8: SERVICE_PRODUCT_ID,
        9: WORKOS_PLATFORM_PRODUCT_ID
    },
    releaseType: {
        105: "New_release",
        156: "Bug_fix",
        0: "Performance",
        1: "Event",
        2: "Announcement",
        4: "Feature_upgrade",
        3: "Apps_and_integrations",
        9: "Gradual_release",
        6: APPS_RECOMMENDED,
        7: APPS_NEW,
        8: APPS_TRENDING
    },
    team: {
        1: "IT",
        0: "HR",
        2: "Marketing",
        9: "Admin_only",
        10: "Finance",
        11: "Engineering",
        12: "Operations",
        13: "Product",
        14: "PMO",
        15: "Company_wide",
        16: "Sales_and_customer_success",
        17: "Creative_and_communications"
    },
    releaseStatus: {
        0: "Beta",
        1: "Live",
        2: "Gradual_release",
        7: "In_the_roadmap"
    },
    plan: {
        2: "Enterprise",
        7: "Basic",
        3: "Standard",
        4: "Pro",
        1: "Free"
    },
    releaseHeighlights: {
        105: true
    },
    benefit: {
        159: "Share_insights",
        4: "Data_driven_decisions",
        106: "Improve_transparency",
        161: "Increase_efficiency",
        158: "Streamline_communication",
        164: "Customize_your_workflow",
        162: "Centralize_data",
        160: "Boost_team_performance",
        163: "Better_manage_your_account",
        157: "Align_your_team",
        166: "Accessibility"
    },
    device: {
        1: "Mobile",
        8: "Tablet",
        2: "Desktop_app",
        9: "Web_browser"
    }
};
const RELEASE_TYPE_BACKGROUND_COLOR = colors[BACKGROUND_GRAY_COLOR_NAME];
const RELEASE_TYPE_TEXT_COLOR = colors[DARK_WORK_OS_IRIS_COLOR_NAME];
const TEAM_BACKGROUND_COLOR = "#FEF8EB";
const TEAM_TEXT_COLOR = "#BC5004";
const BENEFIT_BACKGROUND_COLOR = "#CCE5FF";
const PLAN_BACKGROUND_COLOR = "#CCE5FF";
const DEV_PRODUCT_BACKGROUND_COLOR = "#E8F8F0";
const WORK_FORMS_PRODUCT_BACKGROUND_COLOR = "#FFE8E8";
const WORK_MANAGEMENT_PRODUCT_BACKGROUND_COLOR = "#BABAFD";
const WORK_CANVAS_PRODUCT_TEXT_COLOR = "#1973FF";
const EVENT_RELEASE_TYPE_COLOR = "#EAAA15";
const PERFORMANCE_RELEASE_TYPE_COLOR = "#116846";
const GRADUEL_RELEASE_TYPE_COLOR = "#0073EA";
const SERVICE_TEXT_COLOR = "#FA4270";
const SERVICE_BACKGROUND_COLOR = "#F5EFF1";
export const ID_TO_OPTIONS_NAMES_AND_COLORS = {
    product: {
        data: {
            [WORK_MANAGEMENT_PRODUCT_ID]: {
                name: "monday work management",
                textColor: colors[DARK_WORK_OS_IRIS_COLOR_NAME],
                backgroundColor: WORK_MANAGEMENT_PRODUCT_BACKGROUND_COLOR
            },
            [CRM_PRODUCT_ID]: {
                name: "monday CRM",
                textColor: colors[CRM_DARK_TINT_01],
                backgroundColor: colors[CRM_LIGHTER_TINT_01]
            },
            [DEV_PRODUCT_ID]: {
                name: "monday dev",
                textColor: colors[DARK_DEV_GREEN_COLOR_NAME],
                backgroundColor: DEV_PRODUCT_BACKGROUND_COLOR
            },
            [SERVICE_PRODUCT_ID]: {
                name: "monday service",
                textColor: SERVICE_TEXT_COLOR,
                backgroundColor: SERVICE_BACKGROUND_COLOR
            },
            workCanvas: {
                name: "WorkCanvas",
                textColor: WORK_CANVAS_PRODUCT_TEXT_COLOR,
                backgroundColor: colors[BACKGROUND_GRAY_COLOR_NAME]
            },
            Work_Forms: {
                name: "WorkForms",
                textColor: colors[WORKFORMS_RED_COLOR_NAME],
                backgroundColor: WORK_FORMS_PRODUCT_BACKGROUND_COLOR
            },
            [WORKOS_PLATFORM_PRODUCT_ID]: {
                name: "WorkOS platform",
                textColor: colors[BRAND_BLACK_TEXT_COLOR],
                backgroundColor: colors[GAINSBORO_COLOR_NAME]
            }
        }
    },
    releaseType: {
        data: {
            New_release: {
                name: "New release",
                color: colors[DARK_WORK_OS_IRIS_COLOR_NAME]
            },
            Bug_fix: {
                name: "Bug fix",
                color: colors[BRAND_PRIMARY_GREEN]
            },
            Performance: {
                name: "Performance",
                color: PERFORMANCE_RELEASE_TYPE_COLOR
            },
            Event: {
                name: "Event",
                color: EVENT_RELEASE_TYPE_COLOR
            },
            Announcement: {
                name: "Announcement",
                color: colors[BRAND_PRIMARY_RED]
            },
            Feature_upgrade: {
                name: "Feature upgrade",
                color: colors[CRM_DARKER_TINT_02]
            },
            Apps_and_integrations: {
                name: "Apps & integrations",
                color: colors[WORKFORMS_RED_COLOR_NAME]
            },
            Gradual_release: {
                name: "Gradual release",
                color: GRADUEL_RELEASE_TYPE_COLOR
            }
        },
        backgroundColor: RELEASE_TYPE_BACKGROUND_COLOR,
        textColor: RELEASE_TYPE_TEXT_COLOR
    },
    team: {
        data: {
            IT: {
                name: "IT"
            },
            HR: {
                name: "HR"
            },
            Marketing: {
                name: "Marketing"
            },
            Admin_only: {
                name: "Admin only"
            },
            Finance: {
                name: "Finance"
            },
            Engineering: {
                name: "Engineering"
            },
            Operations: {
                name: "Operations"
            },
            Product: {
                name: "Product"
            },
            PMO: {
                name: "PMO"
            },
            Company_wide: {
                name: "Company wide"
            },
            Sales_and_customer_success: {
                name: "Sales & Customer Success"
            },
            Creative_and_communications: {
                name: "Creative & Communications"
            }
        },
        backgroundColor: TEAM_BACKGROUND_COLOR,
        textColor: TEAM_TEXT_COLOR
    },
    releaseStatus: {
        data: {
            Beta: {
                name: "Beta"
            },
            Live: {
                name: "Live"
            },
            Gradual_release: {
                name: "Gradual release"
            },
            In_the_roadmap: {
                name: "In the roadmap"
            }
        }
    },
    plan: {
        data: {
            Enterprise: {
                name: "Enterprise"
            },
            Pro: {
                name: "Pro"
            },
            Standard: {
                name: "Standard"
            },
            Basic: {
                name: "Basic"
            },
            Free: {
                name: "Free"
            }
        },
        // added colors here so it will not brak if we decide to add plan tag
        backgroundColor: PLAN_BACKGROUND_COLOR,
        textColor: colors.navy
    },
    benefit: {
        data: {
            Share_insights: {
                name: "Share insights"
            },
            Data_driven_decisions: {
                name: "Data-driven decisions"
            },
            Improve_transparency: {
                name: "Improve transparency"
            },
            Increase_efficiency: {
                name: "Increase efficiency"
            },
            Streamline_communication: {
                name: "Streamline communication"
            },
            Customize_your_workflow: {
                name: "Customize your workflow"
            },
            Centralize_data: {
                name: "Centralize data"
            },
            Boost_team_performance: {
                name: "Boost team performance"
            },
            Better_manage_your_account: {
                name: "Better manage your account"
            },
            Align_your_team: {
                name: "Align your team"
            },
            Accessibility: {
                name: "Accessibility"
            }
        },
        backgroundColor: BENEFIT_BACKGROUND_COLOR,
        textColor: colors.navy
    }
};
export const filtersSchema = [
    {
        id: "releaseType",
        title: "Release type",
        data: ID_TO_OPTIONS_NAMES_AND_COLORS.releaseType.data
    },
    {
        id: "product",
        title: "Product",
        data: ID_TO_OPTIONS_NAMES_AND_COLORS.product.data
    },
    {
        id: "team",
        title: "Teams",
        data: ID_TO_OPTIONS_NAMES_AND_COLORS.team.data
    },
    {
        id: "plan",
        title: "Plan",
        data: ID_TO_OPTIONS_NAMES_AND_COLORS.plan.data
    },
    {
        id: "benefit",
        title: "Benefit",
        data: ID_TO_OPTIONS_NAMES_AND_COLORS.benefit.data
    }
];
